function openStockoutPopupOnProductDetail(){
  openStockoutPopup('.restock-rocket-button-cover');
}

function openStockoutPopupOnCategory(selector){
  selector = selector.parentNode.parentNode.parentNode.parentNode;
  openStockoutPopup('.restock-rocket-button', selector);
}

function openStockoutPopup(className, selector){
  if(!selector) {
    selector = document;
  }
  let btnStockout = selector.querySelector(className);
  if(btnStockout){
    btnStockout.click();
  } else {
    setTimeout(function(){
      openStockoutPopup(className, selector);
    }, 100);
  }
}

// efecto para cambiar un icono por otro (accordion-icon-plus => accordion-icon-minus) cuando se despliega un modal (accordion-toggle-button)
document.addEventListener('DOMContentLoaded', function() {
  const toggleButtons = document.querySelectorAll('.accordion-toggle-button');
  toggleButtons.forEach(button => {
    const popoverId = button.getAttribute('aria-controls');
    const popover = document.getElementById(popoverId);
    const iconPlus = button.querySelector('.accordion-icon-plus');
    const iconMinus = button.querySelector('.accordion-icon-minus');
    if (popover) {
      button.addEventListener('click', function() {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          iconPlus.style.display = 'inline-block';
          iconMinus.style.display = 'none';
        } else {
          iconPlus.style.display = 'none';
          iconMinus.style.display = 'inline-block';
        }
        button.setAttribute('aria-expanded', !isExpanded);
      });
      document.addEventListener('click', function(event) {
        if (!popover.contains(event.target) && !button.contains(event.target)) {
          iconPlus.style.display = 'inline-block';
          iconMinus.style.display = 'none';
          button.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
});

function isMobile()
{
    return window.innerWidth < 1000;
}

(function(){
  var containerObserver = null;
  var bodyObserver = null;

  function getImageHeightForThumbnail(thumbnail){
    if (!thumbnail) return 0;
    var img = thumbnail.querySelector('img.snize-item-image');

    if (!img) {
      var itemContainer = thumbnail.closest('.snize-product, .snize-item, li, .snize-grid-item, .snize-results-item');
      if (itemContainer) {
        img = itemContainer.querySelector('img.snize-item-image');
      }
    }

    if (!img) return 0;

    var h = 0;
    try {
      h = Math.round(img.getBoundingClientRect().height);
    } catch(e) {}

    if (!h) {
      h = img.naturalHeight || img.height || 0;
    }

    if (!h) {
      img.addEventListener('load', scheduleAdjust, { once: true });
    }

    return h;
  }

  function adjustSnizeThumbnailsHeight(){
    requestAnimationFrame(function(){
      var container = document.querySelector('#snize-search-results-grid-mode');
      if (!container) return;

      var thumbnails = container.querySelectorAll('span.snize-thumbnail');
      if (!thumbnails || !thumbnails.length) return;

      thumbnails.forEach(function(thumbnail){
        var baseHeight = getImageHeightForThumbnail(thumbnail);
        var total = baseHeight ? (baseHeight + 20) : 0;
        if (total > 0) {
          thumbnail.style.setProperty('height', total + 'px', 'important');
        }
      });
    });
  }

  function debounce(fn, wait){
    var t;
    return function(){
      clearTimeout(t);
      var ctx = this, args = arguments;
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  var scheduleAdjust = debounce(adjustSnizeThumbnailsHeight, 100);

  function observeContainer(container){
    if (!container) return;
    if (containerObserver) {
      try { containerObserver.disconnect(); } catch(e) {}
    }
    containerObserver = new MutationObserver(function(mutations){
      var needs = false;
      for (var i = 0; i < mutations.length; i++){
        var m = mutations[i];
        if (m.type === 'childList' && (m.addedNodes && m.addedNodes.length)) { needs = true; break; }
        if (m.type === 'attributes') { needs = true; break; }
      }
      if (needs) scheduleAdjust();
    });
    containerObserver.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src','srcset','style','class','data-src','data-srcset']
    });
  }

  function watchForContainer(){
    var container = document.querySelector('#snize-search-results-grid-mode');
    if (container) {
      observeContainer(container);
      return;
    }
    if (bodyObserver) return;
    bodyObserver = new MutationObserver(function(){
      var c = document.querySelector('#snize-search-results-grid-mode');
      if (c) {
        observeContainer(c);
        try { bodyObserver.disconnect(); } catch(e) {}
        bodyObserver = null;
        scheduleAdjust();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function(){
    scheduleAdjust();
    watchForContainer();

    var start = Date.now();
    var iv = setInterval(function(){
      scheduleAdjust();
      if (Date.now() - start > 2500) {
        clearInterval(iv);
      }
    }, 200);
  });

  window.addEventListener('load', scheduleAdjust);

  window.addEventListener('resize', scheduleAdjust);

  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible') scheduleAdjust();
  });

  ['snize:loaded','snize:results_loaded','snize:products_rendered','snize:updated','snize:render_finished','snize:after_load'].forEach(function(evt){
    document.addEventListener(evt, scheduleAdjust, true);
  });

})();

function showIOSKeyboard(element)
{
    document.addEventListener('DOMContentLoaded', () => {
        element.focus();
        try {
            element.select();
        } catch {}
    });
    const focusOnFirstInteraction = (e) => {
        element.focus({ preventScroll: true });
        try {
            const len = element.value.length;
            element.setSelectionRange(len, len);
        } catch {}
        window.removeEventListener('touchstart', focusOnFirstInteraction);
        window.removeEventListener('click', focusOnFirstInteraction);
    };
    window.addEventListener('touchstart', focusOnFirstInteraction, { once: true });
    window.addEventListener('click', focusOnFirstInteraction, { once: true });
}